import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarSeatIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.8438 19.5673H6.16586C5.07739 15.4808 3.13185 16.2382 14.0961 17.3679C13.9437 12.3991 14.4635 13.5427 17.3412 9.57772L14.8438 19.5673V19.5673ZM19.7068 2.2373H17.8085C17.2864 2.2373 16.8592 2.66447 16.8592 3.18652V6.03402H19.7068V2.2373ZM19.7071 6.99969H16.8596C14.9531 11.199 12.4261 10.992 12.4261 15.5032C12.4261 15.5032 7.77033 14.9888 6.41918 14.823C4.85462 14.5725 3.5377 15.3404 3.6458 16.8843C3.69657 17.6097 4.95147 21.1967 4.99076 21.2373H16.1477L19.7071 6.99969Z" />
    </SvgIcon>
  );
});
